export const LANGUAGES = ['en', 'nl', 'de', 'fr']

export default t =>
  LANGUAGES.map(option => ({
    value: option,
    label: t(`options.language.${option}`),
  }))
